<template lang="pug">
.item_card_full(
	v-bind:class='classes',
	v-on:click='toLink',
	v-on:mouseover='hover',
	v-on:mouseleave='leave'
)
	.image_container
		.image(v-bind:style='{ backgroundImage: "url(" + imageUrl + ")" }')
	.text
		h2.title(v-if='item.title') {{ item.title }}
		h4.desc(v-if='item.desc') {{ item.desc }}

	CardVertical(
		v-if='classes.includes("detail")',
		v-bind:item='item',
		v-bind:classes='["detail", is_show ? "show" : ""]'
	)
</template>

<script>
import CardVertical from '@/components/CardVertical.vue';
export default {
	props: ['item', 'classes'],
	data() {
		return {
			is_show: false,
		};
	},
	methods: {
		toLink: function () {
			if (this.item.id !== undefined) {
				this.$router.push({
					name: 'Video',
					params: { id: this.item.id },
				});
			} else {
				window.open(this.item.link, '_blank');
			}
		},
		hover: function () {
			if (window.innerWidth > 768) {
				this.is_show = true;
			}
		},
		leave: function () {
			if (window.innerWidth > 768) {
				this.is_show = false;
			}
		},
		hideAll: function () {
			let elements = document.querySelectorAll(
				'.item_card_vertical.show'
			);
			for (let i = 0; i < elements.length; i++) {
				if (elements[i].id !== this.id) {
					elements[i].querySelector('.item_card_vertical').className =
						'item_card_vertical';
				}
			}
		},
	},
	computed: {
		imageUrl: function () {
			if (this.classes.includes('external_link')) {
				return this.item.image;
			} else {
				return require(`@/${this.item.image}`);
			}
		},
	},
	components: {
		CardVertical,
	},
};
</script>

<style lang="stylus">
.item_card_full
	$padding_card_x = 20px
	$padding_card_y = 25px
	width: 100%
	height: 230px
	position: relative
	display: flex
	flex-direction: column
	justify-content: flex-end
	align-items: flex-start
	margin-bottom: 1rem
	border-radius: 15px
	border: 1px solid $color_main
	cursor: pointer
	.image_container
		position: absolute
		left: 0
		top: 0
		width: 100%
		height: 100%
		background-image: url('~@/assets/images/video_default.png')
		background-size: cover
		background-position: center center
		border-radius: 15px
		.image
			position: relative
			width: 100%
			height: 100%
			border-radius: 15px
			background-size: cover
			background-position: center center
			filter: opacity(0.8)
			&:after
				content: ''
				position: absolute
				width: 100%
				height: 100%
				left: 0
				border-radius: 15px
				background: linear-gradient(180deg, rgba(11,46,91,0) 50%, #174e9b 100%)
	.badge
		position: absolute
		top: $padding_card_y
		left: $padding_card_x
		border-radius: 17px
		padding: 4px 14px
		font-size: $fs-5
		font-weight: 400
		color: black
		background-color: $color_yellow
	.text
		position: relative
		padding: $padding_card_y $padding_card_x
		color: white
		.title, .desc
			margin-bottom: 0
			text-align: left
			font-weight: 500
			margin-bottom: 0
		.title
			margin-bottom: 5px
</style>
